import * as $runtime from "../runtime.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Halogen$dVDom$dMachine from "../Halogen.VDom.Machine/index.js";
import * as Halogen$dVDom$dTypes from "../Halogen.VDom.Types/index.js";
import * as Halogen$dVDom$dUtil from "../Halogen.VDom.Util/index.js";
const VDomSpec = x => x;
const haltWidget = v => {
  const $0 = v.widget;
  return Halogen$dVDom$dMachine.halt($0);
};
const patchWidget = (state, vdom) => {
  if (vdom.tag === "Grafted") {
    const $0 = Halogen$dVDom$dTypes.runGraft(vdom._1);
    return patchWidget(state, $0);
  }
  if (vdom.tag === "Widget") {
    const $0 = vdom._1;
    const res = Halogen$dVDom$dMachine.step(state.widget, $0);
    return Halogen$dVDom$dMachine.$Step$p(res._1, {build: state.build, widget: res}, patchWidget, haltWidget);
  }
  haltWidget(state);
  return state.build(vdom);
};
const haltText = v => {
  const $0 = v.node;
  const parent = Halogen$dVDom$dUtil.parentNode($0);
  return Halogen$dVDom$dUtil.removeChild($0, parent);
};
const patchText = (state, vdom) => {
  if (vdom.tag === "Grafted") {
    const $0 = Halogen$dVDom$dTypes.runGraft(vdom._1);
    return patchText(state, $0);
  }
  if (vdom.tag === "Text") {
    if (state.value === vdom._1) { return Halogen$dVDom$dMachine.$Step$p(state.node, state, patchText, haltText); }
    const $0 = vdom._1;
    Halogen$dVDom$dUtil.setTextContent($0, state.node);
    return Halogen$dVDom$dMachine.$Step$p(state.node, {build: state.build, node: state.node, value: $0}, patchText, haltText);
  }
  haltText(state);
  return state.build(vdom);
};
const haltKeyed = v => {
  const $0 = v.attrs;
  const $1 = v.children;
  const $2 = v.node;
  const parent = Halogen$dVDom$dUtil.parentNode($2);
  Halogen$dVDom$dUtil.removeChild($2, parent);
  Halogen$dVDom$dUtil.forInE($1, (v1, s) => Halogen$dVDom$dMachine.halt(s));
  return Halogen$dVDom$dMachine.halt($0);
};
const haltElem = v => {
  const $0 = v.attrs;
  const $1 = v.children;
  const $2 = v.node;
  const parent = Halogen$dVDom$dUtil.parentNode($2);
  Halogen$dVDom$dUtil.removeChild($2, parent);
  Halogen$dVDom$dUtil.forEachE($1, Halogen$dVDom$dMachine.halt);
  return Halogen$dVDom$dMachine.halt($0);
};
const eqElemSpec = (ns1, v, ns2, v1) => v === v1 && (ns1.tag === "Just" ? ns2.tag === "Just" && ns1._1 === ns2._1 : ns1.tag === "Nothing" && ns2.tag === "Nothing");
const patchElem = (state, vdom) => {
  if (vdom.tag === "Grafted") {
    const $0 = Halogen$dVDom$dTypes.runGraft(vdom._1);
    return patchElem(state, $0);
  }
  if (vdom.tag === "Elem" && eqElemSpec(state.ns, state.name, vdom._1, vdom._2)) {
    if (state.children.length === 0 && vdom._4.length === 0) {
      const attrs2 = Halogen$dVDom$dMachine.step(state.attrs, vdom._3);
      return Halogen$dVDom$dMachine.$Step$p(
        state.node,
        {build: state.build, node: state.node, attrs: attrs2, ns: vdom._1, name: vdom._2, children: state.children},
        patchElem,
        haltElem
      );
    }
    const children2 = Halogen$dVDom$dUtil.diffWithIxE(
      state.children,
      vdom._4,
      (ix, s, v2) => {
        const res = Halogen$dVDom$dMachine.step(s, v2);
        Halogen$dVDom$dUtil.insertChildIx(ix, res._1, state.node);
        return res;
      },
      (v2, s) => Halogen$dVDom$dMachine.halt(s),
      (ix, v2) => {
        const res = state.build(v2);
        Halogen$dVDom$dUtil.insertChildIx(ix, res._1, state.node);
        return res;
      }
    );
    const attrs2 = Halogen$dVDom$dMachine.step(state.attrs, vdom._3);
    return Halogen$dVDom$dMachine.$Step$p(state.node, {build: state.build, node: state.node, attrs: attrs2, ns: vdom._1, name: vdom._2, children: children2}, patchElem, haltElem);
  }
  haltElem(state);
  return state.build(vdom);
};
const patchKeyed = (state, vdom) => {
  if (vdom.tag === "Grafted") {
    const $0 = Halogen$dVDom$dTypes.runGraft(vdom._1);
    return patchKeyed(state, $0);
  }
  if (vdom.tag === "Keyed" && eqElemSpec(state.ns, state.name, vdom._1, vdom._2)) {
    const v = vdom._4.length;
    if (state.length === 0 && v === 0) {
      const attrs2 = Halogen$dVDom$dMachine.step(state.attrs, vdom._3);
      return Halogen$dVDom$dMachine.$Step$p(
        state.node,
        {build: state.build, node: state.node, attrs: attrs2, ns: vdom._1, name: vdom._2, children: state.children, length: 0},
        patchKeyed,
        haltKeyed
      );
    }
    const children2 = Halogen$dVDom$dUtil.diffWithKeyAndIxE(
      state.children,
      vdom._4,
      Data$dTuple.fst,
      (v2, ix$p, s, v3) => {
        const $0 = v3._2;
        const res = Halogen$dVDom$dMachine.step(s, $0);
        Halogen$dVDom$dUtil.insertChildIx(ix$p, res._1, state.node);
        return res;
      },
      (v2, s) => Halogen$dVDom$dMachine.halt(s),
      (v2, ix, v3) => {
        const $0 = v3._2;
        const res = state.build($0);
        Halogen$dVDom$dUtil.insertChildIx(ix, res._1, state.node);
        return res;
      }
    );
    const attrs2 = Halogen$dVDom$dMachine.step(state.attrs, vdom._3);
    return Halogen$dVDom$dMachine.$Step$p(
      state.node,
      {build: state.build, node: state.node, attrs: attrs2, ns: vdom._1, name: vdom._2, children: children2, length: v},
      patchKeyed,
      haltKeyed
    );
  }
  haltKeyed(state);
  return state.build(vdom);
};
const buildWidget = (v, build, w) => {
  const res = v.buildWidget(v)(w);
  return Halogen$dVDom$dMachine.$Step$p(res._1, {build, widget: res}, patchWidget, haltWidget);
};
const buildText = (v, build, s) => {
  const $0 = v.document;
  const node = Halogen$dVDom$dUtil.createTextNode(s, $0);
  return Halogen$dVDom$dMachine.$Step$p(node, {build, node, value: s}, patchText, haltText);
};
const buildKeyed = (v, build, ns1, name1, as1, ch1) => {
  const $0 = (() => {
    if (ns1.tag === "Nothing") { return Data$dNullable.null; }
    if (ns1.tag === "Just") { return Data$dNullable.notNull(ns1._1); }
    $runtime.fail();
  })();
  const $1 = v.document;
  const el = Halogen$dVDom$dUtil.createElement($0, name1, $1);
  const children = Halogen$dVDom$dUtil.strMapWithIxE(
    ch1,
    Data$dTuple.fst,
    (v1, ix, v2) => {
      const $2 = v2._2;
      const res = build($2);
      Halogen$dVDom$dUtil.insertChildIx(ix, res._1, el);
      return res;
    }
  );
  const attrs = v.buildAttributes(el)(as1);
  return Halogen$dVDom$dMachine.$Step$p(el, {build, node: el, attrs, ns: ns1, name: name1, children, length: ch1.length}, patchKeyed, haltKeyed);
};
const buildElem = (v, build, ns1, name1, as1, ch1) => {
  const $0 = (() => {
    if (ns1.tag === "Nothing") { return Data$dNullable.null; }
    if (ns1.tag === "Just") { return Data$dNullable.notNull(ns1._1); }
    $runtime.fail();
  })();
  const $1 = v.document;
  const el = Halogen$dVDom$dUtil.createElement($0, name1, $1);
  const children = Halogen$dVDom$dUtil.forE(
    ch1,
    (ix, child) => {
      const res = build(child);
      Halogen$dVDom$dUtil.insertChildIx(ix, res._1, el);
      return res;
    }
  );
  const attrs = v.buildAttributes(el)(as1);
  return Halogen$dVDom$dMachine.$Step$p(el, {build, node: el, attrs, ns: ns1, name: name1, children}, patchElem, haltElem);
};
const buildVDom = spec => {
  const build = v => {
    if (v.tag === "Text") {
      const $0 = v._1;
      return buildText(spec, build, $0);
    }
    if (v.tag === "Elem") {
      const $0 = v._3;
      const $1 = v._4;
      const $2 = v._2;
      const $3 = v._1;
      return buildElem(spec, build, $3, $2, $0, $1);
    }
    if (v.tag === "Keyed") {
      const $0 = v._3;
      const $1 = v._4;
      const $2 = v._2;
      const $3 = v._1;
      return buildKeyed(spec, build, $3, $2, $0, $1);
    }
    if (v.tag === "Widget") {
      const $0 = v._1;
      return buildWidget(spec, build, $0);
    }
    if (v.tag === "Grafted") {
      const $0 = Halogen$dVDom$dTypes.runGraft(v._1);
      return build($0);
    }
    $runtime.fail();
  };
  return build;
};
export {VDomSpec, buildElem, buildKeyed, buildText, buildVDom, buildWidget, eqElemSpec, haltElem, haltKeyed, haltText, haltWidget, patchElem, patchKeyed, patchText, patchWidget};
